import { useToast } from "@adafia/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createNote } from "@/notes/api/notes";
import type { FileNode } from "@/notes/types";

export const useCreateNode = () => {
	const queryClient = useQueryClient();
	const { showToast } = useToast();

	return useMutation({
		mutationFn: ({
			title,
			content,
			isFolder,
			parentId,
		}: {
			title: string;
			content: string | null;
			isFolder: boolean;
			parentId: string | null;
		}) => createNote(title, content, isFolder, parentId),
		onSuccess: (newNode) => {
			// Instantly add the new node to the tree cache
			queryClient.setQueryData<FileNode[]>(["tree"], (old) => {
				if (!old) return [newNode as FileNode];
				if (old.some((n) => n.id === newNode.id)) return old;
				return [...old, newNode as FileNode];
			});
			queryClient.invalidateQueries({ queryKey: ["tree"] });
		},
		onError: (error: Error) => {
			showToast(error.message || "Failed to create note", "error");
		},
	});
};
